import axios from "axios";

export default async function logoutService(type: string) {
    try {
        const res = await axios.post(`/api/logout?key=accountInfo-${type}`);
        if (res.status === 200) {
            return res.data;
        }
    } catch (error) {
        console.error("🚀 ~ logoutService ~ error:", error);
        throw error;
    }
}
